import { ActionsDropdown } from '@app/components/actions-dropdown/ActionsDropdown';
import { StyledButtonGroup } from '@app/components/button-group/ButtonGroup';
import { StyledButton } from '@app/components/button/Button';
import { PageMeta } from '@app/components/meta/Meta';
import { PageHeader } from '@app/components/page/PageHeader';
import { PageLayout } from '@app/components/page';
import { PageTitle } from '@app/components/page/PageTitle';
import { MdOutlineCheckCircle } from 'react-icons/md';
import { TextField } from '@app/components/form-fields/TextField';
import { DatePickerField } from '@app/components/form-fields/DatePickerField';
import { SelectField } from '@app/components/form-fields/SelectField';
import { RadioField } from '@app/components/form-fields/RadioField';
import { CheckboxField } from '@app/components/form-fields/CheckboxField';
import { StyledCard } from '@app/components/card/Card';
import { StyledAlert } from '@app/components/alert/Alert';
import { StyledTable } from '@app/components/table/Table';
import { StyledTag } from '@app/components/tag/Tag';
import { StyledTooltip } from '@app/components/tooltip/Tooltip';
import { TABLE_DATA } from './Styleguide.data';
import type { TableColumnsType } from 'antd';
import { Link } from 'react-router';
import { url } from '@app/utils/constants';
import { HiOutlinePencil } from 'react-icons/hi2';

type DataType = {
    id: number;
    name: string;
    age: number;
    address: string;
};

export const Styleguide = () => {
    const actionMenuItems = (record: DataType) => [
        {
            key: '1',
            onClick: () => alert(JSON.stringify(record, null, 4)),
            label: <p>View</p>,
        },
        {
            key: '2',
            onClick: () => alert('Edit!'),
            label: <p>Edit</p>,
        },
        {
            key: '3',
            disabled: true,
            onClick: () => alert('Delete!'),
            label: <p>Delete</p>,
        },
    ];

    const columns: TableColumnsType<DataType> = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: 300,
        },
        {
            title: 'Age',
            dataIndex: 'age',
            key: 'age',
            width: 100,
        },
        {
            title: 'Address',
            dataIndex: 'address',
            key: 'address',
        },
        {
            key: 'tags',
            width: 150,
            render: () => (
                <StyledButtonGroup justify="flex-start">
                    <StyledTag>Tag 1</StyledTag>
                    <StyledTooltip title="Tooltip message here...">
                        <StyledTag icon={<MdOutlineCheckCircle />} type="primary" color="green">
                            Success
                        </StyledTag>
                    </StyledTooltip>
                </StyledButtonGroup>
            ),
        },
        {
            key: 'actions',
            width: 130,
            fixed: 'right',
            render: (_, record) => (
                <StyledButtonGroup>
                    <StyledButton icon={<HiOutlinePencil />}>Edit</StyledButton>
                    <ActionsDropdown title="Actions" items={actionMenuItems(record)} />
                </StyledButtonGroup>
            ),
        },
    ];

    return (
        <>
            <PageMeta title="Dashboard" />

            <PageHeader
                breadcrumbItems={[
                    {
                        title: <Link to={url.adminPortal.dashboard}>Dashboard</Link>,
                    },
                    { title: 'Styleguide' },
                ]}>
                <PageTitle title="Styleguide" />
            </PageHeader>

            <PageLayout>
                <PageLayout.Content>
                    <div id="formElements">
                        <StyledTable<DataType>
                            dataSource={TABLE_DATA}
                            columns={columns}
                            rowKey={({ id }) => id}
                        />

                        <StyledAlert
                            type="success"
                            title="Message"
                            description="Description goes here"
                            style={{ marginTop: 20 }}
                        />

                        <StyledCard size="small">
                            <form>
                                <TextField
                                    name="text-field"
                                    label="Text Field"
                                    placeholder="Text Field"
                                />

                                <DatePickerField name="date-field" label="Date Picker" />

                                <SelectField
                                    name="select-field"
                                    label="Single Select Field"
                                    placeholder="Select"
                                    options={[
                                        { label: 'Option 1', value: 'option1' },
                                        { label: 'Option 2', value: 'option2' },
                                        { label: 'Option 3', value: 'option3' },
                                    ]}
                                />

                                <SelectField
                                    name="multi-field"
                                    label="Multiple Select Field"
                                    placeholder="Select"
                                    mode="multiple"
                                    options={[
                                        { label: 'Option 1', value: 'option1' },
                                        { label: 'Option 2', value: 'option2' },
                                        { label: 'Option 3', value: 'option3' },
                                    ]}
                                />

                                <RadioField
                                    label="Radio Field"
                                    defaultValue={'option1'}
                                    options={[
                                        { label: 'Option 1', value: 'option1' },
                                        { label: 'Option 2', value: 'option2' },
                                    ]}
                                />

                                <CheckboxField
                                    label="Checkbox Field"
                                    options={[
                                        { label: 'Option 1', value: 'option1' },
                                        { label: 'Option 2', value: 'option2' },
                                    ]}
                                />

                                <StyledButtonGroup justify="flex-start">
                                    <StyledButton>Default Button</StyledButton>
                                    <StyledButton type="primary">Primary Button</StyledButton>
                                </StyledButtonGroup>
                            </form>
                        </StyledCard>
                    </div>
                </PageLayout.Content>
            </PageLayout>
        </>
    );
};

export default Styleguide;
